import get from 'lodash/get'

export function getCsrfToken() {
  return get(document.querySelector("meta[name=csrf-token]"), 'content')
}
